import {
  FormControl, InputLabel, MenuItem, Select,
} from '@mui/material';
import { CreditedStatus } from 'server/es/indexes/posts/search/types';
import { useRouter } from 'next/router';
import { updateRouterQuery } from 'lib/utils/filterUtils';

interface Props {
  defaultValue?: string;
  isProfileOwner?: boolean;
  showSuggestedCreditsFilter?: boolean;
  creditedStatus?: CreditedStatus;
}

export const CreditedStatusFilter = ({
  creditedStatus, defaultValue = 'credited', isProfileOwner, showSuggestedCreditsFilter,
}: Props) => {
  const router = useRouter();

  const onApply = (_creditedStatus?: CreditedStatus) => {
    const defaultCriteriaIfUncreditedOrSuggestedCredits = () => {
      // if fileType already selected
      if (router.query.fileType || _creditedStatus !== 'suggested') return {};

      // if uncredited, select default file types
      return { fileType: ['VIDEO', 'GIF', 'IMAGE'] };
    };

    const changes = {
      ...(_creditedStatus !== creditedStatus && { creditedStatus: _creditedStatus || [] }),
    };

    if (Object.keys(changes).length > 0) {
      const query = {
        ...defaultCriteriaIfUncreditedOrSuggestedCredits(),
        ...changes,
        creditedStatus: _creditedStatus || [],
        sort: _creditedStatus === 'suggested' ? 'relevance' : router.query.sort || [],
      };
      updateRouterQuery(router, query);
    }
  };

  return (
    <>

      <FormControl className="w-full" size="small">
        <InputLabel id="credit-status-label">Credit Status</InputLabel>
        <Select
          name="credit-status-select"
          id="credit-status-select"
          aria-labelledby="credit-status-label"
          value={creditedStatus || defaultValue}
          onChange={(e) => onApply(e.target.value as CreditedStatus)}
          className="w-full"
          label="Credit Status"
        >
          <MenuItem
            key="all"
            value="all"
          >
            All Posts
          </MenuItem>
          <MenuItem
            key="credited"
            value="credited"
          >
            Credited Posts
          </MenuItem>
          <MenuItem
            key="uncredited"
            value="uncredited"
          >
            Uncredited Posts
          </MenuItem>
          {isProfileOwner && (
            <MenuItem
              key="single"
              value="single"
            >
              Single Credit Posts
            </MenuItem>
          )}
          {showSuggestedCreditsFilter && (
            <MenuItem
              key="suggested"
              value="suggested"
            >
              Suggested Credits
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </>
  );
};
